import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    q: "How do insurance agencies get more quote requests in Colorado?",
    a: "Local SEO + dedicated landing pages for each line of business — auto, home, life, commercial, workers' comp. Generic 'insurance services' pages are invisible. Agencies that build per-line pages capture quote requests across every search intent.",
  },
  {
    q: "Is SEO worth it for an independent insurance agent?",
    a: "Yes. 'Insurance agent near me', 'home insurance Colorado Springs', and 'commercial insurance' all have stable, intent-heavy search volume. One commercial policy is worth months of SEO. Captive carriers feed leads; independents need their own pipeline — and SEO is the cheapest one.",
  },
  {
    q: "Should I run Google Ads for insurance?",
    a: "Auto and home insurance CPCs are high, but profitable when paired with strong landing pages and call tracking. Commercial and workers' comp ads convert at much higher margins. We build tight, conversion-focused campaigns instead of broad-match spend.",
  },
  {
    q: "What's the difference between marketing for captive vs independent agents?",
    a: "Captive agents (State Farm, Farmers, Allstate) compete on brand and proximity. Independents compete on choice and savings. Each needs a different content and SEO strategy, and we tailor accordingly.",
  },
  {
    q: "Do you handle commercial insurance and benefits marketing?",
    a: "Yes — those are the highest-value verticals. Dedicated commercial, group benefits, and workers' comp pages outperform generic insurance sites by 3–5x on close rate.",
  },
];

export const Route = createFileRoute("/insurance-agency-marketing-colorado")({
  head: () =>
    industryMarketingHead("Insurance Agency", "insurance agency", "insurance-agency-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry="Insurance Agency"
      industryLower="insurance agency"
      slug="insurance-agency-marketing-colorado"
      subheadline="We help Colorado insurance agencies — captive and independent — build a steady pipeline of quote requests across auto, home, commercial, and benefits."
      painPoints={[
        "Carriers fed you leads for years and now the pipeline has dried up",
        "Your site has one 'insurance services' page and ranks for nothing specific",
        "Commercial and workers' comp prospects never find you — they go to specialist agencies",
      ]}
      serviceDescriptions={{
        seo: "Rank for auto, home, life, commercial, and workers' comp — every line of business, every Colorado market.",
        googleMaps: "Own 'insurance agent near me' in the Map Pack so quote shoppers call you first.",
        webDesign: "Per-line landing pages with one-click quote forms, real reviews, and trust signals.",
        ppc: "Profitable Google Ads tuned to high-margin commercial, benefits, and workers' comp searches.",
        geoAi: "Get cited when buyers ask ChatGPT 'best insurance agent in Colorado Springs' or 'business insurance near me'.",
        socialMedia: "Trust-building content that converts referrals and warm intros into signed policies.",
      }}
      testimonial={{
        quote:
          "We replaced a slow carrier-lead pipeline with steady inbound. Two months in, the commercial page paid for the whole engagement.",
        role: "Independent Agency Owner",
        city: "Colorado Springs",
      }}
      faqs={FAQS}
      cityHubLinks={[
        { to: "/colorado-springs", label: "Insurance agency marketing in Colorado Springs", description: "Compete with captive carriers across the Pikes Peak region." },
        { to: "/denver-digital-marketing", label: "Insurance agency marketing in Denver", description: "Build commercial and benefits pipelines in Denver's competitive insurance market." },
        { to: "/castle-rock-digital-marketing", label: "Insurance agency marketing in Castle Rock", description: "High-net-worth home and commercial policies across Douglas County." },
      ]}
    />
  ),
});
